module.exports = __webpack_public_path__ + "img/page-24.3ca64a7b.jpg";